import { UseCase } from "../../base";
import { LocationsRepository } from "../../repositories";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { Gls } from "../../domain/models/gls.model";

@Injectable({providedIn: 'root'})
export class GetGLSLocationsUsecase implements UseCase<string, Gls[]> {
  constructor(private locationRepository: LocationsRepository) {
  }

  execute(query: string): Observable<Gls[]> {
    return this.locationRepository.getLocationsByAddressFromGLS(query);
  }
}
